import React, { useEffect, useState } from 'react';

import DataGrid from 'react-data-grid';
// import { Toolbar, Data } from 'react-data-grid-addons';

import { Tabela } from './styles';
import api from '../../../services/api';

interface Cancelamentos {
  usuario: string;

  descricao: string;

  data_fechamento: string;

  justificativa: string;
}

const defaultColumnProperties = {
  resizable: true,
};

const columns = [
  {
    key: 'Usuario',
    name: 'Usuário',
    width: 130,
  },
  { key: 'DataFechamento', name: 'Data Fechamento', width: 135 },
  {
    key: 'Justificativa',
    name: 'Justificativa',
  },
  {
    key: 'Descricao',
    name: 'Descrição',
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));

const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis para as datas selecionadas...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};

interface CancelamentoProps {
  dt_inicial: string;
  dt_final: string;
}

const Cancelamentos: React.FC<CancelamentoProps> = ({
  dt_inicial,
  dt_final,
  ...rest
}) => {
  const [rows, setRows] = useState([] as any);

  const cd_empresa = sessionStorage.getItem('cd');

  useEffect(() => {
    api
      .get<Cancelamentos[]>('reports/cancelamentos', {
        params: {
          dt_inicial,
          dt_final,
          cd_empresa,
        },
      })
      .then((response) => {
        const itemsFormatted = [] as Array<any>;

        response.data.forEach((cancelamento) => {
          itemsFormatted.push({
            Usuario: cancelamento.usuario, // .replace(/,/g, ''), // remove commas to avoid errors,
            DataFechamento: cancelamento.data_fechamento,
            Descricao: cancelamento.descricao,
            Justificativa: cancelamento.justificativa,
          });
        });
        setRows(itemsFormatted);
      })
      .catch(() => {
        setRows([]);
        // console.log(error);
      });
  }, [cd_empresa, dt_final, dt_inicial]);

  return (
    <Tabela>
      <h1>DETALHES</h1>
      <DataGrid
        columns={columns}
        rowGetter={(i) => rows[i]}
        rowsCount={rows.length}
        minHeight={400}
        emptyRowsView={EmptyRowsView}
      />
    </Tabela>
  );
};

export default Cancelamentos;
